<template>
  <section class="section__nykart">
    <!-- Floating case study on right top -->
    <!-- <FloatingCaseStudy :caseColor="caseColor" :caseText="caseText"></FloatingCaseStudy> -->
    <!-- All animating objects -->
    <div class="section__nykart--bg">
      <div class="section__nykart--scene" data-aos="fade-up">
        <img
          id="leaf_1"
          class="leaf_1 lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/lisc1_HkbzPWAQvE.png"
          data-src="https://ik.imagekit.io/intervi/lisc1_HkbzPWAQvE.png"
          alt="Table Nykart"
        />
        <div id="phone_box_1">
          <img
            id="phone_1"
            class="phone_1 lazyload"
            src="https://ik.imagekit.io/intervi/tr:w-540,bl-7/phone1_SygJu-CXDV.png"
            data-src="https://ik.imagekit.io/intervi/phone1_SygJu-CXDV.png"
            alt="phone1 Nykart"
          />
        </div>
        <div id="phone_box_2">
          <img
            id="phone_2"
            class="phone_2 lazyload"
            src="https://ik.imagekit.io/intervi/tr:w-650,bl-7/phone2_Bkflu-R7P4.png"
            data-src="https://ik.imagekit.io/intervi/tr:w-650/phone2_Bkflu-R7P4.png"
            alt="phone2 Nykart"
          />
        </div>
        <img
          id="leaf_2"
          class="leaf_2 lazyload"
          src="https://ik.imagekit.io/intervi/tr:bl-7/lisc2_B1lvZCXvE.png"
          data-src="https://ik.imagekit.io/intervi/lisc2_B1lvZCXvE.png"
          alt="Icons Nykart"
        />
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "@/components/small-components/SectionTitle";
import MainSectionFooter from "@/components/small-components/MainSectionFooter";
import FloatingSocials from "@/components/small-components/FloatingSocials";

export default {
  name: "ComponentNykart",
  data() {
    return {};
  },
  props: ["showChild"],
  mounted: function() {
    this.mousePhone1();
    this.mousePhone2();
    this.mouseLeaf1();
    this.mouseLeaf2();
  },
  methods: {
    mousePhone1: function() {
      $(document).mousemove(function(event) {
        $("#phone_1").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            // yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 20,
            ease: Power1.easeOut
          });
        });
      });
    },
    mousePhone2: function() {
      $(document).mousemove(function(event) {
        $("#phone_box_2").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            // yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * 20,
            ease: Power1.easeOut
          });
        });
      });
    },
    mouseLeaf1: function() {
      $(document).mousemove(function(event) {
        $("#leaf_1").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -20,
            ease: Power1.easeOut
          });
        });
      });
    },
    mouseLeaf2: function() {
      $(document).mousemove(function(event) {
        $("#leaf_2").each(function(index, element) {
          var xPos = event.clientX / $(window).width() - 0.5,
            yPos = event.clientY / $(window).height() - 0.5,
            box = element;

          TweenLite.to(box, 1, {
            x: xPos * -40,
            ease: Power1.easeOut
          });
        });
      });
    }
  },
  // Init components
  components: {
    SectionTitle: SectionTitle,
    FloatingSocials: FloatingSocials
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inner-components/ComponentNykart.vue